<section id="social" class="wl-section social">
  <div class="wl-inner inner">
    <h2 class="title">Pokochali to goście i prowadzący</h2>
    <div class="stats">
      @for (stat of stats; track stat.label; let last = $last) {
        <div class="stat" [class.last]="last">
          <div class="stat-value">{{ stat.value }}</div>
          <div class="stat-label">{{ stat.label }}</div>
        </div>
      }
    </div>
    <div class="wl-3col">
      @for (t of testimonials; track t.name) {
        <div class="quote-card">
          <p class="quote">„{{ t.quote }}"</p>
          <div class="author">
            <div class="avatar"></div>
            <div>
              <div class="name">{{ t.name }}</div>
              <div class="role">{{ t.role }}</div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</section>
